

<div class="modal-header bg-white justify-content-end">
  <a class="link-hover fw-light" (click)="close()">
    <i class="fa-regular fa-xmark fa-lg fs-4" title="Stäng"></i> Stäng
  </a>
</div>

<div class="modal-body">
  <iframe
      [src]="safeUrl"
      style="height: 100%; opacity: 1;"
      class="iframe vh-100 border-0 w-100 d-block bg-white"
      allowtransparency="true"
      frameborder="0"
      scrolling="auto vh-100"
      allowfullscreen>
  </iframe>
</div>
